export default __webpack_public_path__ + "56212effcc68a5283784a884093399c6.png";